export function mapStateToPropsForAllData(state) {
    return {
        allDataOfContact: state.allDataOfUser.allDataOfContact,
        searchedDataOfContact: state.allDataOfUser.searchedDataOfContact
      }
}